module.exports = __webpack_public_path__ + "csgdc-dfd835eb.webp";